import React, { useState } from "react";
import BACKGROUND_IMAGE from "../../assets/BgOverlayImage.jpeg";
import StarRatings from "react-star-ratings";
import CALENDAR_ICON from "../../assets/Calendar.png";
import CALENDAR_BLANK_ICON from "../../assets/CalendarBlank.png";
import CLOCK_ICON from "../../assets/Clock.png";
import BOOK_ICON from "../../assets/BookOpenText.png";
import DOWNLOAD_ICON from "../../assets/DownLoadIcon.png";
import { Link, useNavigate } from "react-router-dom";
import { Card, CardContent } from "../../components/ui/card";
import { useDispatch } from "react-redux";
import handleBuy from "../Buy/handleBuy";
import { ITEM_COURSE } from "../../constants/text_constants";
import { useSelector } from "react-redux";

const DescriptionBanner = ({
  courseHeaders,
  isPurchased = "0",
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  
  const isSideBarOpen = useSelector(
    (store) => store.sidebar.isSideBarOpen
  );

  const [showPlanPopup, setShowPlanPopup] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedCourse, setSelectedCourse] = useState(null);

  const openBuyPopup = (course) => {
    const plans = Array.isArray(course?.payment_plans)
      ? course.payment_plans.filter(Boolean)
      : [];

    if (plans.length === 0) {
      
      handleBuy(
        dispatch,
        navigate,
        course?.id,
        ITEM_COURSE,
        course?.name,
        course?.offer_price,
        course?.offer_discount,
        course?.price,
        course?.principal_amount,
        course?.course_banner,
        course?.course_icon
      );

      return;
    }

    setSelectedCourse(course);
    setSelectedPlan(null);
    setShowPlanPopup(true);
  };

  const continueToPayment = () => {
    if (!selectedPlan || !selectedCourse) return;

    console.log("plan--",selectedPlan?.id);

    const finalPrice =
      Number(selectedPlan?.offer_discount || 0) > 0
        ? selectedPlan?.offer_price
        : selectedPlan?.price;

    handleBuy(
      dispatch,
      navigate,
      selectedCourse?.id,
      ITEM_COURSE,
      selectedCourse?.name,
      finalPrice,
      selectedPlan?.offer_discount,
      selectedPlan?.price,
      selectedCourse?.principal_amount,
      selectedCourse?.course_banner,
      selectedCourse?.course_icon,
      selectedPlan?.id
    );

    setShowPlanPopup(false);
  };

  return (
    <>
      <div
        style={{
          backgroundImage: `linear-gradient(to right, rgba(254, 246, 250, 0.9) 45%, rgba(102, 269, 244, 0.8)), url('${BACKGROUND_IMAGE}')`,
          backgroundSize: "cover",
          fontFamily: "DM Sans",
          fontStyle: "normal",
        }}
        className="
          lg:h-[23rem]
          h-[40rem]
          px-[5rem]
          py-[3rem]
          text-[#130C40]
          flex
          relative
          -left-[1rem]
          w-screen
        "
      >
        {/* LEFT SECTION */}
        <div>
          <div>
            {courseHeaders?.details?.map((ele, i) => (
              <div
                className="flex flex-col gap-5"
                key={i}
              >
                {/* Rating */}
                <div className="flex gap-3">
                  <div>
                    <StarRatings
                      rating={Math.floor(ele?.rating)}
                      starRatedColor="#FCB129"
                      numberOfStars={5}
                      starDimension="1.2rem"
                    />
                  </div>

                  <div className="mt-[0.2rem] flex gap-2">
                    <div className="font-bold">
                      {ele?.rating}
                    </div>

                    <div className="font-light italic">
                      ({ele?.total_rating})
                    </div>
                  </div>
                </div>

                {/* Course Name */}
                <div className="font-bold text-5xl">
                  {ele?.name}
                </div>

                {/* Description */}
                <div className="w-[40rem] text-sm">
                  {ele?.sub_description}
                </div>

                {/* Course Info */}
                <div className="flex gap-10">
                  {/* Start Date */}
                  <div className="flex items-start gap-2">
                    <div>
                      <img
                        src={CALENDAR_BLANK_ICON}
                        alt={ele?.starts_on}
                        className="mt-1"
                        loading="lazy"
                      />
                    </div>

                    <div>
                      <div className="text-[#82808D]">
                        Start Date:
                      </div>
                      <div>{ele?.starts_on}</div>
                    </div>
                  </div>

                  {/* End Date */}
                  <div className="flex items-start gap-2">
                    <div>
                      <img
                        src={CALENDAR_BLANK_ICON}
                        alt={ele?.ends_on}
                        className="mt-1"
                        loading="lazy"
                      />
                    </div>

                    <div>
                      <div className="text-[#82808D]">
                        End Date:
                      </div>
                      <div>{ele?.ends_on}</div>
                    </div>
                  </div>

                  {/* Validity */}
                  <div className="flex items-start gap-2">
                    <div>
                      <img
                        src={CALENDAR_ICON}
                        alt="Validity"
                        className="mt-1"
                        loading="lazy"
                      />
                    </div>

                    <div>
                      <div className="text-[#82808D]">
                        Validity:
                      </div>
                      <div>{ele?.validity}</div>
                    </div>
                  </div>

                  {/* Total Hours */}
                  <div className="flex items-start gap-2">
                    <div>
                      <img
                        src={CLOCK_ICON}
                        alt="Total Hours"
                        className="mt-1"
                        loading="lazy"
                      />
                    </div>

                    <div>
                      <div className="text-[#82808D]">
                        Total Hours:
                      </div>
                      <div>{ele?.duration}</div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Syllabus */}
          <div className="mt-3">
            <div className="flex items-start gap-2">
              <div>
                <img
                  src={BOOK_ICON}
                  alt=""
                  className="mt-1"
                  loading="lazy"
                />
              </div>

              <div>
                <div className="text-[#82808D]">
                  Syllabus
                </div>

                <div className="mt-1 flex gap-2">
                  {courseHeaders?.schedules?.map(
                    (ele, i) => (
                      <Link
                        to={ele?.attachment}
                        target="_blank"
                        key={i}
                      >
                        <div
                          className="
                            mx-1
                            flex
                            cursor-pointer
                            items-center
                            gap-2
                            rounded-full
                            bg-[#5A277C]
                            px-3
                            py-1
                            transition-all
                            hover:-translate-y-1
                          "
                        >
                          <div className="font-semibold text-white">
                            {ele?.title}
                          </div>

                          <div>
                            <img
                              src={DOWNLOAD_ICON}
                              alt={ele?.title}
                              loading="lazy"
                            />
                          </div>
                        </div>
                      </Link>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div>
          <div
            className={
              "absolute " +
              (isSideBarOpen
                ? "top-[8rem] right-[12rem] md:top-[10rem] md:right-[6rem]"
                : "top-[22rem] right-2 md:top-[22rem] md:right-4 lg:top-[13rem] lg:right-10 xl:top-[13rem] xl:right-[10rem]")
            }
          >
            <Card className="border border-white shadow-xl">
              <CardContent
                style={{ fontFamily: "DM Sans" }}
                className="lg:aspect-square lg:p-0"
              >
                <div>
                  {courseHeaders?.details?.map(
                    (ele, i) => {
                      const payPlanId = ele?.payment_plan_id;
                      /* FIX: plans are declared inside the same
                         map where they are being used */
                      const plans = Array.isArray(
                        ele?.payment_plans
                      )
                        ? ele.payment_plans.filter(Boolean)
                        : [];

                        const paymentPlans = plans.slice(0, 4);

                        const purchasedPlanValidity = Number(
                          ele?.plan_validity || 0
                        );
                        
                      return (
                        <div
                          className="
                            flex
                            flex-col
                            items-center
                            justify-center
                            gap-3
                          "
                          key={i}
                        >
                          {/* IMAGE */}
                          <div>
                            {ele?.course_banner ? (
                              <img
                                src={ele.course_banner}
                                alt={ele?.name || "Course"}
                                className="
                                  h-[10rem]
                                  w-[22rem]
                                  rounded-t-lg
                                  object-cover
                                  md:w-[19rem]
                                "
                                loading="lazy"
                                onError={(e) => {
                                  e.currentTarget.style.display =
                                    "none";

                                  const placeholder =
                                    e.currentTarget.parentElement.querySelector(
                                      ".course-banner-placeholder"
                                    );

                                  if (placeholder) {
                                    placeholder.classList.remove(
                                      "hidden"
                                    );
                                  }
                                }}
                              />
                            ) : null}

                            {/* Placeholder */}
                            <div
                              className={`
                                course-banner-placeholder
                                ${
                                  ele?.course_banner
                                    ? "hidden"
                                    : ""
                                }
                                flex
                                h-[10rem]
                                w-[22rem]
                                flex-col
                                items-center
                                justify-center
                                rounded-t-lg
                                bg-gradient-to-br
                                from-[#F3EFF6]
                                to-[#E7E1EB]
                                md:w-[19rem]
                              `}
                            >
                              <div
                                className="
                                  flex
                                  h-12
                                  w-12
                                  items-center
                                  justify-center
                                  rounded-full
                                  bg-white
                                  shadow-sm
                                "
                              >
                                <span className="text-xl font-bold text-[#5A277C]">
                                  R
                                </span>
                              </div>

                              <span className="mt-1 px-2 text-center text-sm font-semibold text-[#5A277C]">
                                {ele?.name || "Course"}
                              </span>
                            </div>
                          </div>

                          {/* AVERAGE / MIDDLE PLAN */}
                          {/* PAYMENT PLANS PRICING */}
{paymentPlans.length > 0 && (
  <div className="grid w-[18rem] grid-cols-3 gap-2">
    {paymentPlans.map((plan) => {
      const discount = Number(plan?.offer_discount || 0);
      const hasDiscount = discount > 0;

      const finalPrice = hasDiscount
        ? plan?.offer_price
        : plan?.price;

        const isPurchasedPlan =
  isPurchased === "1" &&
  String(plan?.id) === String(payPlanId);


      return (
        <div
          key={plan?.id}
          className={`
            relative
            min-w-0
            rounded-xl
            border
            px-2
            py-2
            text-center
            shadow-sm
            transition-all
            ${
              isPurchasedPlan
                ? "border-[#5A277C] bg-[#F5ECF9] ring-2 ring-[#5A277C]/30"
                : "border-[#E2D9E8] bg-white"
            }
          `}
        >
          {/* Discount */}
          {hasDiscount && (
            <div className="mb-1 text-[9px] font-semibold text-[#5A277C]">
              {discount}% OFF
            </div>
          )}

          {/* Original Price */}
          {hasDiscount && (
            <div className="text-[9px] text-gray-400 line-through">
              ₹{plan?.price}
            </div>
          )}

          {/* Final Price */}
          <div className="text-base font-bold text-[#5A277C]">
            ₹{finalPrice}
          </div>

          {/* Validity */}
          <div className="text-[10px] font-medium text-[#77747C]">
            for {plan?.validity || 0} Months
          </div>
        </div>
      );
    })}
  </div>
)}

                          {/* BUY NOW - only when plans exist */}
                          {plans.length > 0 &&
                            isPurchased === "0" && (
                              <button
                                className="
                                  mt-5
                                  w-[18rem]
                                  cursor-pointer
                                  rounded-xl
                                  bg-[#5A277C]
                                  py-1
                                  font-semibold
                                  text-white
                                  transition-all
                                  hover:bg-[#472063]
                                "
                                onClick={() =>
                                  openBuyPopup(ele)
                                }
                              >
                                Buy Now
                              </button>
                            )}

                          {/* Purchased */}
                          {isPurchased === "1" && (
                            <div
                              className="
                                mt-[1rem]
                                w-[18rem]
                                rounded-xl
                                bg-gradient-to-r
                                from-cyan-400
                                to-purple-600
                                py-1
                                text-center
                                font-semibold
                                text-white
                              "
                            >
                              Course Purchased
                            </div>
                          )}
                        </div>
                      );
                    }
                  )}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>

      {/* PAYMENT PLAN POPUP */}
      {showPlanPopup && selectedCourse && (
        <div
          className="
            fixed
            inset-0
            z-[9999]
            flex
            items-center
            justify-center
            bg-black/50
            px-4
          "
        >
          <div
            className="
              relative
              w-full
              max-w-md
              rounded-2xl
              bg-white
              p-5
              shadow-2xl
            "
            style={{ fontFamily: "DM Sans" }}
          >
            {/* Close */}
            <button
              type="button"
              onClick={() => {
                setShowPlanPopup(false);
                setSelectedPlan(null);
                setSelectedCourse(null);
              }}
              className="
                absolute
                right-4
                top-3
                text-xl
                text-gray-500
                hover:text-gray-800
              "
            >
              ×
            </button>

            {/* Heading */}
            <div className="mb-4 pr-6">
              <h2 className="text-lg font-bold text-[#222]">
                Select Payment Plan
              </h2>

              <p className="mt-1 text-xs text-[#77747C]">
                {selectedCourse?.name}
              </p>
            </div>

            {/* Plans */}
            <div className="grid grid-cols-3 gap-2">
              {(
                Array.isArray(
                  selectedCourse?.payment_plans
                )
                  ? selectedCourse.payment_plans.filter(
                      Boolean
                    )
                  : []
              ).map((plan) => {
                const discount = Number(
                  plan?.offer_discount || 0
                );

                const hasDiscount = discount > 0;

                const finalPrice = hasDiscount
                  ? plan?.offer_price
                  : plan?.price;

                const isSelected =
                  selectedPlan?.id === plan?.id;

                return (
                  <button
                    type="button"
                    key={plan?.id}
                    onClick={() =>
                      setSelectedPlan(plan)
                    }
                    className={`
                      rounded-xl
                      border
                      px-2
                      py-3
                      text-center
                      transition-all
                      ${
                        isSelected
                          ? "border-[#5A277C] bg-[#F5ECF9] ring-2 ring-[#5A277C]/20"
                          : "border-[#DDD8E2] bg-white hover:border-[#5A277C]"
                      }
                    `}
                  >
                    <div className="text-base font-bold text-[#5A277C]">
                      ₹{finalPrice}
                    </div>

                    {hasDiscount && (
                      <div className="text-[10px] text-gray-400 line-through">
                        ₹{plan?.price}
                      </div>
                    )}

                    <div className="mt-1 text-xs font-semibold text-[#333]">
                      {plan?.validity || 0} Months
                    </div>

                    {hasDiscount && (
                      <div className="mt-1 text-[10px] font-semibold text-[#5A277C]">
                        {discount}% OFF
                      </div>
                    )}
                  </button>
                );
              })}
            </div>

            {/* Continue */}
            <button
              type="button"
              disabled={!selectedPlan}
              onClick={continueToPayment}
              className={`
                mt-5
                w-full
                rounded-xl
                py-2.5
                text-sm
                font-bold
                transition-all
                ${
                  selectedPlan
                    ? "bg-[#5A277C] text-white hover:bg-[#472063]"
                    : "cursor-not-allowed bg-gray-200 text-gray-400"
                }
              `}
            >
              Continue to Payment
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default DescriptionBanner;